import sensorDataConfigApi from '@/api/config/sensorDataConfig'
import { SearchParams } from '@/types'

import { RootState } from '@/store/stores'
import { SensorList } from '@/types/sensor'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { initialState } from '@store/slices/SoilMoistureDashboard/types'
import { payloadSoils } from '@/features/operations/helpers/chartSoil'

export const fetchAllSoilMoisture = createAsyncThunk(
  'soilMoistureDashboard/fetchAllSoilMoisture',
  async (
    params: {
      interfaceId: number
      stationId: number
      searchParams?: SearchParams
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await sensorDataConfigApi.getSoilSensor(
        params.interfaceId,
        params.stationId,
        params.searchParams,
      )

      return data as SensorList[]
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchSoilMoistureHistoricalData = createAsyncThunk(
  'soilMoistureDashboard/fetchSoilMoistureHistoricalData',
  async (
    params: {
      interfaceId: number
      sensorId: number
      payload: {
        fromDate: string
        endDate: string
        isAvg: boolean
        stationId?: number
      }
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await sensorDataConfigApi.getSoilSensorId(
        params.interfaceId,
        params.sensorId,
        {
          fromDate: params.payload.fromDate,
          endDate: params.payload.endDate,
          isAvg: params.payload.isAvg,
          stationId: params.payload?.stationId,
        },
      )

      return data as SensorList[]
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const soilMoistureDashboardSlice = createSlice({
  name: 'soilMoistureDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchAllSoilMoisture
      .addCase(fetchAllSoilMoisture.pending, (state) => {
        state.isLoadingSensors = true
      })
      .addCase(fetchAllSoilMoisture.fulfilled, (state, action) => {
        state.isLoadingSensors = false
        state.sensors = action.payload
      })
      .addCase(fetchAllSoilMoisture.rejected, (state) => {
        state.isLoadingSensors = false
      })
  },
})

export const soilMoistureDashboardState = (state: RootState) =>
  state.soilMoistureDashboard

export default soilMoistureDashboardSlice.reducer
